export default function StatsSection() {
  const stats = [
    {
      number: '+10',
      label: 'سنوات خبرة',
      icon: 'ri-time-line'
    },
    {
      number: '+50',
      label: 'مشروع',
      icon: 'ri-building-line'
    },
    {
      number: '+20',
      label: 'شريك',
      icon: 'ri-team-line'
    }
  ];

  return (
    <section className="py-16 bg-[#595A5C]">
      <div className="container mx-auto px-4">
        <div className="grid grid-cols-1 md:grid-cols-3 gap-8">
          {stats.map((stat, index) => (
            <div key={index} className="text-center text-white">
              <div className="w-16 h-16 bg-[#E71B25] rounded-full flex items-center justify-center mx-auto mb-4">
                <i className={`${stat.icon} text-2xl`}></i>
              </div>
              <div className="text-4xl font-bold mb-2">{stat.number}</div>
              <div className="text-lg text-gray-200">{stat.label}</div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}